// extracted by mini-css-extract-plugin
module.exports = {"sCentersContainer":"Form-module__sCentersContainer","btn":"Form-module__btn","inFront":"Form-module__inFront","inFront2":"Form-module__inFront2"};